// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*# sourceMappingURL=AppContainer.css.map *//* index.css */

/* Container for the input */
.search-input-container {
    position: relative;
    width: 100%;
  }
  
  /* Style for the input field */
  .search-input {
    border-radius: 20px;
    height: 36px;
    padding: 0 16px;
    width: 100%; 
    transition: box-shadow 0.3s ease-in-out;
    border: 1px solid #6a6a6a; /* Default border style */
  }
  
  /* Pulsating glow effect */
  @keyframes pulsate {
    0% {
      box-shadow: 0 0 10px rgba(255, 255, 0, 0.8); /* Initial glow */
    }
    50% {
      box-shadow: 0 0 30px rgba(255, 255, 0, 0.6); /* Expanded glow */
    }
    100% {
      box-shadow: 0 0 10px rgba(255, 255, 0, 0.8); /* Back to initial glow */
    }
  }
  
  /* Apply subtle effect when focused */
  .search-input.focused {
    border-color: #6a6a6a; /* Keep default border color */
    /* Removed pulsating animation and yellow effects */
  }`, "",{"version":3,"sources":["webpack://./src/pages/Search/index.css"],"names":[],"mappings":"AAAA,2CAA2C,CAAC,cAAc;;AAE1D,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,WAAW;EACb;;EAEA,8BAA8B;EAC9B;IACE,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,uCAAuC;IACvC,yBAAyB,EAAE,yBAAyB;EACtD;;EAEA,0BAA0B;EAC1B;IACE;MACE,2CAA2C,EAAE,iBAAiB;IAChE;IACA;MACE,2CAA2C,EAAE,kBAAkB;IACjE;IACA;MACE,2CAA2C,EAAE,yBAAyB;IACxE;EACF;;EAEA,qCAAqC;EACrC;IACE,qBAAqB,EAAE,8BAA8B;IACrD,mDAAmD;EACrD","sourcesContent":["/*# sourceMappingURL=AppContainer.css.map *//* index.css */\n\n/* Container for the input */\n.search-input-container {\n    position: relative;\n    width: 100%;\n  }\n  \n  /* Style for the input field */\n  .search-input {\n    border-radius: 20px;\n    height: 36px;\n    padding: 0 16px;\n    width: 100%; \n    transition: box-shadow 0.3s ease-in-out;\n    border: 1px solid #6a6a6a; /* Default border style */\n  }\n  \n  /* Pulsating glow effect */\n  @keyframes pulsate {\n    0% {\n      box-shadow: 0 0 10px rgba(255, 255, 0, 0.8); /* Initial glow */\n    }\n    50% {\n      box-shadow: 0 0 30px rgba(255, 255, 0, 0.6); /* Expanded glow */\n    }\n    100% {\n      box-shadow: 0 0 10px rgba(255, 255, 0, 0.8); /* Back to initial glow */\n    }\n  }\n  \n  /* Apply subtle effect when focused */\n  .search-input.focused {\n    border-color: #6a6a6a; /* Keep default border color */\n    /* Removed pulsating animation and yellow effects */\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
